import { Commit, ActionTree, Dispatch } from 'vuex';
import { State } from './vm.store';
import * as types from '@/store/modules/vm/vm-types';
import { AxiosResponse } from 'axios';
import graphQl from '@/services/graphQl';
import { Context, Params } from '@/utils/types/global';
import graphHelpers from '@/utils/graphHelper';
import { Scope } from '@/components/Mobile/constants';
import { getDateTimeFromUnixTimestamp } from '@/utils/time/localtime';
import { KeyLabel } from '@/store/mutations-typesCommon';
import { SubTypes } from '@/utils/capabilties/vm/constatnts';

const actions: ActionTree<State, any> = {
  async SET_CURRENT_VM(
    context: { commit: Commit; rootState: any; dispatch: Dispatch },
    params: { vm: { key: String; label: String }; duration: any }
  ) {
    let vmMetaProperties: any;
    const { vmSubType } = context.rootState.vmState.vmCommonState;
    if (vmSubType === SubTypes.WINDOWS) {
      vmMetaProperties = types.WindowsMetaProperties;
    } else if (vmSubType === SubTypes.LINUX) {
      vmMetaProperties = types.LinuxMetaProperties;
    }
    await context.dispatch(types.vmActions.GET_VM_SERVICE_INSTANCES, {
      duration: params.duration,
      instanceId: params.vm.key,
      teamId: context.rootState.globalState.user.teamID,
      properties: vmMetaProperties
    });
  },
  async SET_CURRENT_VM_SERVICE(
    context: { commit: Commit; rootState: any; dispatch: Dispatch },
    params: { vm: { key: String; label: String } }
  ) {
    context.commit(types.vmMutations.SET_CURRENT_VM_SERVICE, params.vm);
  },
  getVmGraphData(context: Context, params: Params) {
    const { currentVmService } = context.rootState.vmState.vmCommonState;
    const { currentVmInstance } = context.rootState.vmState.vmCommonState;

    const { vmSubType } = context.rootState.vmState.vmCommonState;
  
    /**
     *
     * variable  for determining the service type .
     * @description this is database query , if normal is true then the entity is database else it is for application
     * @param {boolean}
     */
    const normal = params.dashboardType.isDatabase ? false : true;
    const names = ['readSampledRecords', 'sortMetrics'];
  
    const config = graphHelpers.createConfig(context, params, vmSubType);
    const  isCompareOptionsSelected  = context.rootState.globalState.settings.isCompareOptionsSelected;  
    if (!config || !config.metricName || !config.queryMetricType) {
      return;
    }
  
    const metricNames = graphHelpers.parse(config.metricName);

    const labels = graphHelpers.parse(config.labelsIndex || '');

    /**
     * @description add the current VM service
     * @param {string}
     */
    const currentVmId = config.independentSelector
      ? config.currentVmId
      : currentVmService.key;
    const currentInstanceId = currentVmInstance.key;
    const iscompared = isCompareOptionsSelected;
  
    const variablesList = graphHelpers.createVariableList(
      metricNames,
      params,
      config,
      names,
      labels,
      normal,
      currentVmId,
      currentInstanceId,
      iscompared
    );
  
    if (!variablesList || !variablesList.length) {
      return;
    }
    if (isCompareOptionsSelected && 
      (config.queryMetricType === "readMetricsValues" || config.queryMetricType === "readLabeledMetricsValues")) {
     variablesList.forEach(obj => {
       obj.durationCurrent = params.duration;
       obj.durationCompare = params.compareDuration;
     });
   }
  
    let query = isCompareOptionsSelected ? config.queryMetricType + 'Compare' : config.queryMetricType;  
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          return graphQl
            .graphQuery(variable, query) 
            .then((res: AxiosResponse<any>) => {
              const resData = res.data.data;
              return {
                ...resData,
                config,
                metricName: variable.condition.name,
              };
            });
        } else {
          return { config };
        }
      })
    ).then((data: any) => {
      return data;
    });
  },
  
  async getVMData(
    context: { commit: Commit; rootState: any; state: State },
    params: { serviceReq: any; duration: any }
  ): Promise<any> {
    if (!params.serviceReq) {
      params.serviceReq = {
        capability: 'V'
      };
    }
    return graphQl
      .query('queryAllServices')
      .params(params)
      .then(async (res: AxiosResponse) => {
        context.commit('setVMServices', res.data.data.services);
        const currentService = context.state.currentVmService;
        if(!currentService.key) {
          context.commit('setCurrentVMService', res.data.data.services[0]);
        }
      }).catch(err=> err);
  },
  async selectVMService(
    context: { commit: Commit; dispatch: Dispatch },
    params: { key: any }
  ): Promise<any> {
    if (!params.key) {
      return;
    }
    context.commit('setCurrentVMService', params);
  },
  async [types.vmActions.GET_VM_SERVICE_INSTANCES](
    context: Context,
    params: {
      duration: any;
      instanceId: String;
      teamId: String;
      properties: any;
    }
  ) {
    if (!params.instanceId) {
      return;
    }
    return graphQl
      .query('getQueryVMInstances')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data.data) {
          context.commit(
            `${types.vmMutations.SET_CURRENT_VM_INSTANCE}`,
            res.data ? res.data.data.getInstanceDetail : []
          );
        } else return [];
      });
  },

  async [types.vmActions.GET_VM_DISK_UTILITY](
    context: Context,
    params: { duration: any; serviceId: String }
  ) {
    if (!params.serviceId) {
      return;
    }
    const { currentVmInstance } = context.rootState.vmState.vmCommonState;
    let availableBytes: KeyLabel[] = [];
    let usedBytes: KeyLabel[] = [];
    let totalBytes: KeyLabel[] = [];
    availableBytes = await graphQl
      .query('queryLatestValue')
      .params({
        duration: params.duration,
        condition: {
          name: types.VMMetricNames.DISK_UTILITY_AVAILABLE_BYTES,
          entity: {
            scope: Scope.SERVICEINSTANCE,
            serviceName: params.serviceId,
            serviceInstanceName: currentVmInstance.key,
            normal: true
          }
        },
        labels: ['']
      })
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.readLabeledMetricsLatestValue;
        } else return [];
      })
      .catch(error => {
        console.log('GET_QUERY failed ' + error.message);
      });
    usedBytes = await graphQl
      .query('queryLatestValue')
      .params({
        duration: params.duration,
        condition: {
          name: types.VMMetricNames.DISK_UTILITY_USED_BYTES,
          entity: {
            scope: Scope.SERVICEINSTANCE,
            serviceName: params.serviceId,
            serviceInstanceName: currentVmInstance.key,
            normal: true
          }
        },
        labels: ['']
      })
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.readLabeledMetricsLatestValue;
        } else return [];
      })
      .catch(error => {
        console.log('GET_QUERY failed ' + error.message);
      });
    totalBytes = await graphQl
      .query('queryLatestValue')
      .params({
        duration: params.duration,
        condition: {
          name: types.VMMetricNames.DISK_UTILITY_TOTAL_BYTES,
          entity: {
            scope: Scope.SERVICEINSTANCE,
            serviceName: params.serviceId,
            serviceInstanceName: currentVmInstance.key,
            normal: true
          }
        },
        labels: ['']
      })
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.readLabeledMetricsLatestValue;
        } else return [];
      })
      .catch(error => {
        console.log('GET_QUERY failed ' + error.message);
      });
    const diskUtility1: any[] = [];
    //TODO: Add a check here to match all the array sizes
    if (
      usedBytes.length === totalBytes.length &&
      availableBytes.length === totalBytes.length
    ) {
      usedBytes.forEach(function(v: KeyLabel, i) {
        var obj = {
          used: {
            textValue: 'Used Memory',
            formatData: true,
            data: {} as KeyLabel
          },
          available: {
            textValue: 'Available Memory',
            formatData: true,
            data: {} as KeyLabel
          },
          total: {
            textValue: 'Total Memory',
            formatData: true,
            data: {} as KeyLabel
          }
        };
        obj.used.data = v;
        obj.available.data = availableBytes.find(
          el => el.label === v.label
        ) as KeyLabel;

        obj.total.data = totalBytes.find(
          ele => ele.label === v.label
        ) as KeyLabel;
        diskUtility1.push(obj);
      });
    }

    return diskUtility1;
  },
  async [types.vmActions.GET_VM_CARD_DETAILS](
    context: Context,
    params: { duration: any; serviceId: String; metrics: any[] }
  ) {
    if (!params.serviceId) {
      return;
    }
    const { currentVmInstance } = context.rootState.vmState.vmCommonState;
    const cardDetails: any[] = [];
    let querType = '';

    for (var item of params.metrics) {
      if (item.quertType === types.VMMetricType.READ_METRICS_VALUE) {
        querType = 'queryMeterValue';
      } else {
        querType = 'queryMeterCount';
      }
      const data = await graphQl
        .query(querType)
        .params({
          duration: params.duration,
          condition: {
            name: item.metricName,
            entity: {
              scope: Scope.SERVICEINSTANCE,
              serviceName: params.serviceId,
              serviceInstanceName: currentVmInstance.key,
              normal: true
            },
            isLatestValue : item.isLatestValue
          },
          labels: ['']
        })
        .then((res: AxiosResponse) => {
          if (res.data) {
            return res.data.data;
          } else return [];
        })
        .catch(error => {
          console.log('GET_QUERY failed ' + error.message);
        });
      //TODO: Add a check here to match all the array sizes
      var infoObject = {
        metricName: item.metricName,
        value: data
      };
      cardDetails.push(infoObject);
    }

    return cardDetails;
  },
  async [types.vmActions.GET_VM_APP_POOL_EVENTS](
    context: Context,
    params: { duration: any; serviceId: String }
  ) {
    if (!params.serviceId) {
      return;
    }
    const { currentVmInstance } = context.rootState.vmState.vmCommonState;

    return graphQl
      .query('queryLatestValue')
      .params({
        duration: params.duration,
        condition: {
          name: types.VMMetricNames.APP_POOL_EVENTS,
          entity: {
            scope: Scope.SERVICEINSTANCE,
            serviceName: params.serviceId,
            serviceInstanceName: currentVmInstance.key,
            normal: true
          }
        },
        labels: ['']
      })
      .then((res: AxiosResponse) => {
        if (res.data) {
          res.data.data.readLabeledMetricsLatestValue;
          const tableData = res.data.data.readLabeledMetricsLatestValue.map(
            e => ({
              ...e,
              event: 'Application Pool restarted',
              startTime: getDateTimeFromUnixTimestamp(e.value * 1000)
            })
          );
          return tableData;
        } else return [];
      })
      .catch(error => {
        console.log('GET_QUERY failed ' + error.message);
      });
  },
  async [types.vmActions.GET_VM_PROCESS_CPU_DATA](
    context: Context,
    params: { sortCriteria: any; duration: any; serviceId: String }
  ) {
    if (!params.serviceId) {
      return;
    }
    const { currentVmInstance } = context.rootState.vmState.vmCommonState;

    return graphQl
      .query('queryLatestValue')
      .params({
        duration: params.duration,
        condition: {
          name: types.VMMetricNames.PROCESS_CPU_USAGE,
          entity: {
            scope: Scope.SERVICEINSTANCE,
            serviceName: params.serviceId,
            serviceInstanceName: currentVmInstance.key,
            normal: true
          },
        },
        labels: [],
        sortCriteria: params.sortCriteria,
      })
      .then((res: AxiosResponse) => {
        if (res.data) {
          res.data.data.readLabeledMetricsLatestValue;
          const tableData = res.data.data.readLabeledMetricsLatestValue.map(
            e => {
              const [_, processName, processId, processPath]  = e.label.match(/^(.*?)-(\d+)-(.*)$/);
                return {
                    processName,
                    processId,
                    processPath: processPath || '-',
                    processCpu: e.value
                };
            }
          );
          return tableData;
        } else return [];
      })
      .catch(error => {
        console.log('GET_QUERY failed ' + error.message);
      });
  },
  async [types.vmActions.GET_VM_PROCESS_RAM_DATA](
    context: Context,
    params: { sortCriteria: any; duration: any; serviceId: String }
  ) {
    if (!params.serviceId) {
      return;
    }
    const { currentVmInstance } = context.rootState.vmState.vmCommonState;

    return graphQl
      .query('queryLatestValue')
      .params({
        duration: params.duration,
        condition: {
          name: types.VMMetricNames.PROCESS_RAM_USAGE,
          entity: {
            scope: Scope.SERVICEINSTANCE,
            serviceName: params.serviceId,
            serviceInstanceName: currentVmInstance.key,
            normal: true
          },
        },
        labels: ['process_id'],
        sortCriteria: params.sortCriteria,
      })
      .then((res: AxiosResponse) => {
        if (res.data) {
          res.data.data.readLabeledMetricsLatestValue;
          const tableData = res.data.data.readLabeledMetricsLatestValue.map(
            e => {
              const [_, processName, processId, processPath]  = e.label.match(/^(.*?)-(\d+)-(.*)$/);
                return {
                    processName,
                    processId,
                    processPath: processPath || '-',
                    processRam: e.value
                };
            }
          );
          return tableData;
        } else return [];
      })
      .catch(error => {
        console.log('GET_QUERY failed ' + error.message);
      });
  }
};

export default actions;
